export default __webpack_public_path__ + "static/media/about_us_2.2e917c2b.jpeg";